import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_MINIHUB } from "app/auth/baseAsapMiniHub";

export const getListaPedidos = createAsyncThunk(
  "listaPedidosMiniHubApp/listaPedidosMiniHub/getListaPedidos",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_MINIHUB.get("/pedidos/MINIHUB", {
        params: params,
      });
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);
